import { ReactElement } from "react";
import useIntl from "react-intl/src/components/useIntl";

import { PhoneNumberMessageClass } from "~frontend/__generated__/graphql";

export function useMessageClassDisplayName(): (
  messageClass: PhoneNumberMessageClass
) => string {
  const intl = useIntl();

  return (messageClass: PhoneNumberMessageClass) => {
    switch (messageClass) {
      case PhoneNumberMessageClass.TenDlc:
        return intl.formatMessage({
          defaultMessage: "10 DLC",
          description: "Label for 10DLC message class",
        });
      case PhoneNumberMessageClass.TollFree:
        return intl.formatMessage({
          defaultMessage: "Toll-Free",
          description: "Label for toll-free message class",
        });
      case PhoneNumberMessageClass.Unregistered:
        return intl.formatMessage({
          defaultMessage: "Unregistered",
          description: "Label for unregistered message class",
        });
      case PhoneNumberMessageClass.ShortCode:
        return intl.formatMessage({
          defaultMessage: "Short Code",
          description: "Label for short code message class",
        });
      default: {
        const _exhaustiveCheck: never = messageClass;
        return _exhaustiveCheck;
      }
    }
  };
}

export function MessageClassDisplayName({
  messageClass,
}: {
  messageClass: PhoneNumberMessageClass;
}): ReactElement {
  const messageClassDisplayNames = useMessageClassDisplayName();
  return <>{messageClassDisplayNames(messageClass)}</>;
}
